/** Slugs used by ServiceGuide section content (HeadingsWithParagraphsList, FAQs, etc.). */
export const SERVICE_GUIDE_SLUGS = new Set([
  "architectural-services",
  "air-conditioning-and-heating",
  "bricklaying-and-blockwork",
  "cabinet-making",
  "carpentry",
  "carpet-and-flooring",
  "caulking-services",
  "cleaning-services",
  "concrete-and-paving",
  "conveyancing",
  "curtains-blinds-and-awnings",
  "decking-gazebo-and-carports",
  "demolition-and-excavation",
  "electrical-services",
  "engineering-services",
  "fencing-and-gates",
  "glass-and-glazing",
  "garden-and-landscaping",
  "handyman-services",
  "inspections-and-surveyors",
  "security-and-automation",
  "insulation-services",
  "interior-design",
  "locksmiths",
  "painting-and-decorating",
  "moving-and-delivery",
  "mould-and-asbestos",
  "pest-control",
  "solid-plastering",
  "plumbing",
  "pools-and-spas",
  "rendering",
  "renovation-and-restoration",
  "roofing",
  "scaffolding",
  "shopfitting",
  "skip-bins",
  "solar-power",
  "staircase-services",
  "stonework",
  "tiling",
  "waterproofing",
]);

/**
 * Maps granular business category slugs (BusinessCategories.js) to consolidated
 * service guide content slugs.
 */
export const BUSINESS_CATEGORY_TO_SERVICE_GUIDE_SLUG = {
  plumbing: "plumbing",
  "gas-fitting": "plumbing",
  drainage: "plumbing",
  "hot-water-systems": "plumbing",
  electrical: "electrical-services",
  "ev-chargers": "electrical-services",
  carpentry: "carpentry",
  "cabinet-making": "cabinet-making",
  builders: "renovation-and-restoration",
  "restumping-and-underpinning": "renovation-and-restoration",
  roofing: "roofing",
  guttering: "roofing",
  skylights: "roofing",
  "painting-and-decorating": "painting-and-decorating",
  tiling: "tiling",
  flooring: "carpet-and-flooring",
  "epoxy-floors": "carpet-and-flooring",
  plastering: "solid-plastering",
  bricklaying: "bricklaying-and-blockwork",
  concreting: "concrete-and-paving",
  waterproofing: "waterproofing",
  demolition: "demolition-and-excavation",
  scaffolding: "scaffolding",
  "rubbish-removal": "skip-bins",
  excavation: "demolition-and-excavation",
  landscaping: "garden-and-landscaping",
  "tree-services": "garden-and-landscaping",
  "tree-removal": "garden-and-landscaping",
  "retaining-walls": "garden-and-landscaping",
  "fencing-and-gates": "fencing-and-gates",
  "garage-doors": "fencing-and-gates",
  decking: "decking-gazebo-and-carports",
  "pergola-and-verandahs": "decking-gazebo-and-carports",
  hvac: "air-conditioning-and-heating",
  "air-conditioning": "air-conditioning-and-heating",
  "heating-systems": "air-conditioning-and-heating",
  refrigeration: "air-conditioning-and-heating",
  "underfloor-heating": "air-conditioning-and-heating",
  "solar-systems": "solar-power",
  "security-systems": "security-and-automation",
  "home-automation": "security-and-automation",
  "glass-and-glazing": "glass-and-glazing",
  "shower-screens": "glass-and-glazing",
  "screens-and-doors": "glass-and-glazing",
  "pools-and-spas": "pools-and-spas",
  "pest-control": "pest-control",
  cleaning: "cleaning-services",
  "cleaning-services": "cleaning-services",
  "mould-remediation": "mould-and-asbestos",
  asbestos: "mould-and-asbestos",
  "blinds-and-curtains": "curtains-blinds-and-awnings",
  "awnings-and-shades": "curtains-blinds-and-awnings",
  "building-consultants": "architectural-services",
  "interior-design": "interior-design",
  drafting: "architectural-services",
  "plans-and-permits": "architectural-services",
  "building-inspection": "inspections-and-surveyors",
  "building-inspections": "inspections-and-surveyors",
  surveying: "inspections-and-surveyors",
  insulation: "insulation-services",
  handymen: "handyman-services",
  locksmiths: "locksmiths",
  shopfitting: "shopfitting",
  "stone-benchtops": "stonework",
  engineering: "engineering-services",
  staircases: "staircase-services",
  "renovation-and-extension": "renovation-and-restoration",
  rendering: "rendering",
  cladding: "rendering",
  caulking: "caulking-services",

  // Public-Facing Names surfaced on the home page alongside Trade Categories.
  "drainage-plumbing": "plumbing",
  "roof-plumbing": "roofing",
  "pendant-lighting": "electrical-services",
  "smoke-alarms": "electrical-services",
  "pergolas-and-verandahs": "decking-gazebo-and-carports",
  "wall-panelling": "carpentry",
  "bathroom-renovations": "renovation-and-restoration",
  "kitchen-renovations": "renovation-and-restoration",
  "home-extensions": "renovation-and-restoration",
  "roof-restoration": "roofing",
  wallpapering: "painting-and-decorating",
  "roof-painting": "painting-and-decorating",
  carpet: "carpet-and-flooring",
  "epoxy-flooring": "carpet-and-flooring",
  "self-levelling": "carpet-and-flooring",
  "polished-concrete": "concrete-and-paving",
  "concrete-grinding": "concrete-and-paving",
  "waterproofing-leak-repairs": "waterproofing",
  "rising-damp-treatment": "waterproofing",
  "turf-installation": "garden-and-landscaping",
  "commercial-refrigeration": "air-conditioning-and-heating",
  "building-drafting": "architectural-services",
  "land-surveying": "inspections-and-surveyors",
  "structural-engineering": "engineering-services",
  "building-permits": "architectural-services",
};

export function resolveServiceGuideSlug(slug) {
  if (!slug) return null;
  if (SERVICE_GUIDE_SLUGS.has(slug)) return slug;
  return BUSINESS_CATEGORY_TO_SERVICE_GUIDE_SLUG[slug] ?? null;
}

export function getServiceGuidePath(categorySlug) {
  const guideSlug = resolveServiceGuideSlug(categorySlug);
  return guideSlug ? `/services-guide/${guideSlug}` : "/services-guide";
}
